import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class GuestService {

    private verifyTokenUrl = //'https://ijagu59gdg.execute-api.us-west-1.amazonaws.com/default/test-verify-anonymous-link';
    'https://3i5189snqd.execute-api.us-west-1.amazonaws.com/default/pwa-verify-anonymous-link';
    private guestAccessUrl = 'https://YOUR_API_GATEWAY_URL/guest/access';
    private generateTokenUrl = 'https://3ggwypf0o4.execute-api.us-west-1.amazonaws.com/default/pwa-generate-anonymous-link';
    
    constructor(private http: HttpClient) { }

    /**
     * `browserFingerprint` lets the backend recognise a guest whose stored uid
     * belongs to a different event (they joined another one since).
     */
    verifyGuestToken(token: string, uid: string | null = null, browserFingerprint: string | null = null): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json'
        });

        // Build URL with token and optional UID parameter
        let url = `${this.verifyTokenUrl}?token=${token}`;
        if (uid) {
            url += `&uid=${uid}`;
        }

        const body = browserFingerprint ? { browser_fingerprint: browserFingerprint } : {};
        return this.http.post(url, body, { headers });
    }

    getGuestAccessData(token: string): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        });

        return this.http.get(this.guestAccessUrl, { headers });
    }

    saveGuestInfo(user_hex: any, name: string, email: string, eventId: string, browserFingerprint?: string): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/x-www-form-urlencoded'
        });

        let params = new HttpParams()
            .set("visitor_name", name)
            .set("user_hex", user_hex)
            .set("visitor_email", email)
            .set("event_id", eventId);

        // Add browser fingerprint if provided
        if (browserFingerprint) {
            params = params.set("browser_fingerprint", browserFingerprint);
        }

        const saveGuestUrl = //'https://z0icppdmeg.execute-api.us-west-1.amazonaws.com/default/test-save-guest-info';
        'https://deoi7g3sf0.execute-api.us-west-1.amazonaws.com/default/pwa-save-guest-data';

        return this.http.post(saveGuestUrl, params.toString(), { headers });
    }

    /**
     * Replaces a quick-join guest's auto name (guest-MMDD-HHmmss) with the one
     * they typed. pwa-save-guest-data's `rename` action takes the guest's uid
     * from the verified Firebase ID token, so a guest can only rename itself.
     */
    renameGuest(idToken: string, name: string, eventId: string): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/x-www-form-urlencoded'
        });

        const params = new HttpParams()
            .set("action", "rename")
            .set("id_token", idToken)
            .set("visitor_name", name)
            .set("event_id", eventId);

        return this.http.post(
            'https://deoi7g3sf0.execute-api.us-west-1.amazonaws.com/default/pwa-save-guest-data',
            params.toString(), { headers });
    }

    generateAnonymousLink(eventId: string): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json'
        });

        return this.http.post(this.generateTokenUrl, { eventId }, { headers });
    }

    /**
     * Silently create (or retrieve) a guest Firebase session for the demo event.
     * Uses the event hex as the user_hex so the backend can auto-generate a
     * per-event demo guest account and return a Firebase custom token.
     */
    createDemoGuestSession(eventHex: string, eventId: string, visitorName: string = 'Demo User'): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/x-www-form-urlencoded'
        });

        const params = new HttpParams()
            .set('visitor_name', visitorName)
            .set('user_hex', eventHex)
            .set('visitor_email', '')
            .set('event_id', eventId)
            .set('is_demo', 'true');

        const saveGuestUrl = 'https://deoi7g3sf0.execute-api.us-west-1.amazonaws.com/default/pwa-save-guest-data';
        return this.http.post(saveGuestUrl, params.toString(), { headers });
    }
}
